import React from "react"
import Layout from "./layout"
import { Block, Section, Header } from "./ui/mastercard"
import AppInfoBlock from "./ui/appinfoblock"
import ProductBlockNew from "./ui/productblockNew"
import RelatedAppsBlockNew from "./ui/relatedappsblockNew"
import PdfRender from "./el/pdfrender"
import VideoPage from "./ui/videopage"
import { H1, H2, DangerCitation, TextColumns } from "./el/appnotetypography"

const ResourceLayoutNew = props => {
  const pageData = props.pagedata
  const relatedApps = props.relatedApps || []
  const productData = props.productData || []
  const productRelatedData = props.productRelatedData || []

  return (
    <Layout noheader title={pageData.pagetitle}>
      <Block theme="whitefull">
        <Header tight></Header>
        <Section general grid gap normal>
          {/* sidebar right on every page*/}
          <div className="col-span-1 mb-8 lg:order-2 lg:col-span-2">
            {pageData.type !== "job" && (
              <AppInfoBlock
                type={pageData.type}
                productLine={pageData.productLine}
                title={pageData.title}
                description={pageData.description}
                link={pageData.link}
              />
            )}

            {pageData.type !== "job" && pageData.product.length > 0 && (
              <ProductBlockNew
                type={pageData.type}
                productData={productData}
                productRelatedData={productRelatedData}
              ></ProductBlockNew>
            )}
          </div>
          {/* main content */}
          <div className="col-span-1 rounded-sm shadow-lg lg:order-1 lg:col-span-6">
            <div className="h-full rounded-sm bg-white px-4 pb-24 pt-12 shadow-sm md:px-10">
              {/* PDF page */}
              {pageData.display === "pdf" && (
                <div className="">
                  <div className="">
                    <H2 className="mt-0">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: pageData.title,
                        }}
                      />
                    </H2>
                    <DangerCitation content={pageData.citation} />
                  </div>
                  <div className="appnoteStyles my-6 border-b-2 border-slate-300">
                    <p
                      className="text-slate-600"
                      dangerouslySetInnerHTML={{
                        __html: pageData.description,
                      }}
                    ></p>
                  </div>
                  <div className="mx-auto w-full xl:w-10/12">
                    <PdfRender file={pageData.link} />
                  </div>
                </div>
              )}
              {/* video page */}
              {pageData.display === "video" && (
                <VideoPage
                  id={pageData.type}
                  description={pageData.description}
                  title={pageData.title}
                  url={pageData.link}
                />
              )}
              {/* link page */}
              {pageData.display === "link" && (
                <>
                  <H1>{pageData.title}</H1>
                  <DangerCitation content={pageData.citation} />
                  <div className="appnoteStyles mt-2">
                    <TextColumns>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: pageData.description,
                        }}
                      ></p>
                    </TextColumns>
                  </div>
                </>
              )}
              {/* related notes if there are any */}
              {pageData.relatednote && pageData.relatednote.length > 0 && (
                <RelatedAppsBlockNew relatedApps={relatedApps} />
              )}
            </div>
          </div>
        </Section>
      </Block>
    </Layout>
  )
}

export default ResourceLayoutNew
